import clsx from 'clsx'
import { useMemo } from 'react'
import { forwardRef } from 'react'
import { InputHTMLAttributes } from 'react'
import { ReactNode } from 'react'

import css from './scss/Checkbox.module.scss'

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>((props, ref) => {
  const { className, label, error, ...rest } = props

  return useMemo(
    () => (
      <div className={clsx(css.checkbox, className)}>
        <input
          ref={ref}
          type="checkbox"
          className={clsx(css.input, {
            [css['input--error']]: error,
          })}
          {...rest}
        />
        {label && (
          <label className={css.label} htmlFor={props.id}>
            {label}
          </label>
        )}
      </div>
    ),
    [label, props.checked, error]
  )
})

export interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: ReactNode
  error?: boolean
}

export default Checkbox
